import React, { ChangeEvent } from "react";
import { TextField, TextFieldProps } from "@mui/material";

interface TelefoneFieldProps
  extends Omit<TextFieldProps, "onChange" | "inputProps"> {
  label: string;
  value: string;
  fixo?: boolean;
  customClass?: string;
  onChange: (value: string) => void;
}

const TelefoneField: React.FC<TelefoneFieldProps> = ({
  label,
  value,
  fixo,
  customClass,
  onChange,
  ...rest
}) => {
  const formatarTelefone = (telefone: string): string => {
    const numeros = telefone.replace(/\D/g, "");

    if (numeros.length === 11) {
      // Formato: (XX)XXXXX-XXXX
      return numeros.replace(/(\d{2})(\d{5})(\d{4})/, "($1)$2-$3");
    } else if (numeros.length === 10) {
      // Formato: (XX)XXXX-XXXX
      return numeros.replace(/(\d{2})(\d{4})(\d{4})/, "($1)$2-$3");
    } else if (numeros.length >= 2 && numeros.length <= 4) {
      // Formato: (XX)
      return numeros.replace(/(\d{2})(\d+)/, "($1)$2");
    } else {
      // Formato: (XX)XXXXX-XXXX
      return numeros.replace(/(\d{2})(\d{1,5})(\d{1,5})/, "($1)$2-$3");
    }
  };

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const novoTelefone = formatarTelefone(e.target.value);
    onChange(novoTelefone);
  };

  return (
    <TextField
      size="small"
      variant="standard"
      data-testid="telefone"
      label={label}
      value={formatarTelefone(value)}
      onChange={handleChange}
      InputProps={{
        disableUnderline: true,
        className: customClass,
        inputProps: {
          maxLength: fixo ? 13 : 14,
        },
      }}
      InputLabelProps={{
        shrink: true,
      }}
      {...rest}
    />
  );
};

export default TelefoneField;
